export default "/images/vendor/flag-icon-css/flags/4x3/lt.svg?4c19d3a9f8cb00a45baa5b619cc1dc21";